/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import { InputMask } from '@react-input/mask';
import { IMaskedInputLayout } from '../../types/layouts/masked-input';
import { IFormItemProps } from '../../factories/form';

const MaskedInput = ({
    defaultValue, formDataLoaded, formRef, formKey, mask, replacement,
}: IMaskedInputLayout['config'] & IFormItemProps) => {
    const [value, setValue] = useState<string>('');

    useEffect(() => {
        if (formDataLoaded) {
            const values = formRef.getFieldsValue();
            setValue(values[formKey] || defaultValue || '');
        }
    }, [formDataLoaded]);

    useEffect(() => {
        if (formRef && typeof value === 'string') {
            formRef.setFieldsValue({
                [formKey]: value,
            });
        }
    }, [value]);

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.value);

    const getReplacement = () => {
        if (replacement instanceof Object) {
            return Object.keys(replacement).reduce((prev, key) => ({
                ...prev,
                [key]: new RegExp(replacement[key]),
            }), {});
        }
        return replacement;
    };

    return (
        <InputMask
            className="ant-input"
            mask={mask || ''}
            replacement={getReplacement()}
            value={value}
            onChange={onChange}
        />
    );
};

export default MaskedInput;
